import constants from "./constants";

export default {
  Debtors: {
    displayName: "Debtors",
    iconClass: "fa-user",
    field: "DebtorList",
    endpoint: "Debtors",
    path: "debtors",
    productFamily: constants.PRODUCT_FAMILY.LB,
  },
  Settings: {
    displayName: "Settings",
    iconClass: "fa-cog",
    field: "SettingsResource",
    path: "settings",
    productFamily: constants.PRODUCT_FAMILY.LB,
  },
  GlobalSettings: {
    displayName: "Global Settings",
    iconClass: "fa-cog",
    field: "GlobalSettingsList",
    endpoint: "Settings",
    path: "global-settings",
    productFamily: constants.PRODUCT_FAMILY.LB,
  },
  Logs: {
    displayName: "AppInsights Logs",
    iconClass: "fa-wrench",
    field: "LogsResource",
    path: "logs",
    productFamily: constants.PRODUCT_FAMILY.LB,
  },
  EnhancedLogs: {
    displayName: "Enhanced Logs",
    iconClass: "fa-wrench",
    field: "EnhancedLogsGrid",
    path: "enhanced-logs",
    productFamily: constants.PRODUCT_FAMILY.LB,
  },
  FlyAmericaAct: {
    displayName: "Fly America Act",
    iconClass: "fa-plane",
    field: "FlyAmericaResource",
    endpoint: "FlyAmericaAct",
    path: "fly-america",
    productFamily: constants.PRODUCT_FAMILY.LB,
  },
  CreditCards: {
    displayName: "Credit Cards",
    iconClass: "fa-credit-card",
    field: "CreditCardsList",
    endpoint: "CreditCards",
    path: "credit-cards",
    productFamily: constants.PRODUCT_FAMILY.LB,
  },
  PointsOfInterest: {
    displayName: "Points of Interest",
    iconClass: "fa-map-marker",
    field: "PointsOfInterestList",
    path: "points-of-interest",
    endpoint: "",
    productFamily: constants.PRODUCT_FAMILY.LB,
  },
  AirlineCarriers: {
    displayName: "Airline Carriers",
    iconClass: "fa-plane",
    field: "AirlineCarriersList",
    endpoint: "AirlineCarriers",
    path: "airline-carriers",
    productFamily: constants.PRODUCT_FAMILY.LB,
  },
  Airports: {
    displayName: "Airports",
    iconClass: "fa-plane",
    field: "AirportsList",
    endpoint: "Airports",
    path: "airports",
    productFamily: constants.PRODUCT_FAMILY.LB,
  },
  CarSuppliers: {
    displayName: "Car Suppliers",
    iconClass: "fa-car",
    field: "CarSuppliersList",
    endpoint: "CarSuppliers",
    path: "car-suppliers",
    productFamily: constants.PRODUCT_FAMILY.LB,
  },
  CarSupplierLocations: {
    displayName: "Car Supplier Locations",
    iconClass: "fa-car",
    field: "CarSuppliersLocations",
    endpoint: "CarSupplierLocations",
    path: "car-supplier-locations",
    productFamily: constants.PRODUCT_FAMILY.LB,
  },
  Hotels: {
    rootNode: true,
    displayName: "Hotels",
    iconClass: "fa-bed",
    field: "HotelsList",
    path: "hotels",
    endpoint: "",
    productFamily: constants.PRODUCT_FAMILY.LB,
  },
  HotelSupplierMembershipPrograms: {
    displayName: "Hotel Suppliers",
    iconClass: "fa-bed",
    field: "HotelSuppliersResource",
    path: "hotel-supplier-membership-programs",
    productFamily: constants.PRODUCT_FAMILY.LB,
  },
  PerDiem: {
    displayName: "Per Diem",
    iconClass: "fa-bed",
    field: "PerDiem",
    endpoint: "PerDiem",
    path: "per-diem",
    productFamily: constants.PRODUCT_FAMILY.LB,
  },
  RailSuppliers: {
    displayName: "Rail Suppliers",
    iconClass: "fa-train",
    field: "RailSuppliersList",
    endpoint: "RailSuppliers",
    path: "rail-suppliers",
    productFamily: constants.PRODUCT_FAMILY.LB,
  },
  RailStations: {
    displayName: "Rail Stations",
    iconClass: "fa-train",
    field: "RailStationsList",
    endpoint: "RailStations",
    path: "rail-stations",
    productFamily: constants.PRODUCT_FAMILY.LB,
  },
  RailCards: {
    displayName: "Rail Cards",
    iconClass: "fa-train",
    field: "RailCardsList",
    endpoint: "RailCards",
    path: "rail-cards",
    productFamily: constants.PRODUCT_FAMILY.LB,
  },
  CompanyReferenceList: {
    displayName: "Company Reference",
    iconClass: "fa-cog",
    field: "CompanyReferenceList",
    endpoint: "CompanyReferenceList",
    path: "company-reference-list",
    productFamily: constants.PRODUCT_FAMILY.CTM,
  },
  CompanyReferenceConfig: {
    displayName: "Company Reference Config",
    iconClass: "fa-cog",
    field: "CompanyReferenceConfig",
    endpoint: "CompanyReferenceConfig",
    path: "company-reference-config",
    productFamily: constants.PRODUCT_FAMILY.CTM,
  },
  EnhancedPolicyRules: {
    displayName: "Enhanced Policy Rules",
    iconClass: "fa-cog",
    field: "EnhancedPolicyRules",
    endpoint: "EnhancedPolicyRules",
    path: "enhanced-policy-rules",
    productFamily: constants.PRODUCT_FAMILY.CTM,
  },
  ProcessUploadStatus: {
    displayName: "Process Upload Status",
    iconClass: "fa-cog",
    field: "ProcessUploadStatus",
    endpoint: "ProcessUploadStatus",
    path: "process-upload-status",
    productFamily: constants.PRODUCT_FAMILY.CTM,
  },
  SafScores: {
    displayName: "Manage SAF Scores",
    iconClass: "fa-cog",
    field: "SafScoresList",
    endpoint: "SafScores",
    path: "saf-scores",
    productFamily: constants.PRODUCT_FAMILY.CTM,
  },
  VendorPreferenceConfigs: {
    displayName: "Vendor Preference Config",
    iconClass: "fa-cog",
    field: "VendorPreferenceConfigs",
    path: "vendor-preference-configs",
    productFamily: constants.PRODUCT_FAMILY.SupplierRelations,
  },
};


// WEBPACK FOOTER //
// ./src/config/siteStructureConfig.js